import React from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as Info} from 'assets/svg/helper.svg';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';

import {firstStepChanged} from 'models/orders/create';
import {colors} from 'theme';

import {
    ProductTypesButtonContent,
    ProductTypesButtons,
    ProductTypesDescription,
    ProductTypesIconSection,
    ProductTypesWrapper,
} from '../styled';

export const ProductTypes = () => {
    const {t} = useTranslation();

    return (
        <ProductTypesWrapper>
            <ProductTypesIconSection>
                <Icon
                    source={Info}
                    width={20}
                    height={20}
                    fillColor={'transparent'}
                    strokeColor={colors.brandPrimary}
                />
            </ProductTypesIconSection>
            <ProductTypesDescription>
                <span>{t('pages.orders.form.pleaseIndicate')}</span>
                <ProductTypesButtons>
                    <Button
                        style={{
                            display: 'flex',
                            height: 'fit-content',
                            flex: 1,
                            maxWidth: '50%',
                            minHeight: 102,
                        }}
                        variant={ButtonVariant.Outline}
                        size="sm"
                        type="button"
                        onClick={() => firstStepChanged({productTypes: 'import'})}
                    >
                        <ProductTypesButtonContent>
                            <span>{t('pages.orders.form.importedProducts')}</span>
                            <span>{t('pages.orders.form.productsManufacturedAbroad')}</span>
                        </ProductTypesButtonContent>
                    </Button>
                    <Button
                        style={{
                            display: 'flex',
                            height: 'fit-content',
                            flex: 1,
                            maxWidth: '50%',
                            minHeight: 102,
                        }}
                        variant={ButtonVariant.Outline}
                        size="sm"
                        type="button"
                        onClick={() => firstStepChanged({productTypes: 'local'})}
                    >
                        <ProductTypesButtonContent>
                            <span>{t('pages.orders.form.locallyProducedProducts')}</span>
                            <span>{t('pages.orders.form.productsManufacturedDomestically')}</span>
                        </ProductTypesButtonContent>
                    </Button>
                </ProductTypesButtons>
            </ProductTypesDescription>
        </ProductTypesWrapper>
    );
};
